import React from "react";
import clsx from "clsx";

interface ITimelineData {
  id: number;
  title: string;
  description: string;
}

const CareerTimeline: React.FC = () => {
  const timelineData: ITimelineData[] = [
    {
      id: 1,
      title: "Find a role that suits you",
      description:
        "Discover open positions and find your desired job role via job listings or social media.",
    },
    {
      id: 2,
      title: "Send your application",
      description:
        "Mail Your CV to hr@dreamweaversindia.com, along with your contact details.",
    },
    {
      id: 3,
      title: "Receive your interview invite",
      description:
        "We review all applications within 3 working days and send invitation to candidates.",
    },
    {
      id: 4,
      title: "Choose an interview slot",
      description:
        "You will have a friendly discussion with the HR Head and your supervisor to talk about work, life, and more.",
    },
    {
      id: 5,
      title: "Preliminary Interview",
      description:
        "Sometimes, we ask candidates to participate in some technical challenge that is designated to demonstrate candidates' proficiency.",
    },
    {
      id: 6,
      title: "Meet the your teammates",
      description:
        "To us is crucial to make sure all team members feel comfortable.  It is why we do try to have diverse but culturally fitted team members.",
    },
    {
      id: 7,
      title: "Interview with our CMD",
      description: "Your colleagues are excited to welcome you with open arms.",
    },
    {
      id: 8,
      title: "Start a new journey!",
      description: "",
    },
  ];

  return (
    <div
      className="w-full min-h-screen pt-32 sm:pt-44 md:pt-[18rem] xl:pt-[16rem]"
      style={{
        backgroundImage: "url('/careers/career-timeline-bg.svg')",
        backgroundRepeat: "no-repeat",
        // backgroundSize: "cover",
      }}
    >
      <div className="flex flex-col justify-center items-center px-5 lg:px-10">
        <h3 className="text-xl text-center sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
          How to become a <span className="font-bold">Dreamer</span> with{" "}
          <span className="font-bold">Dream Weavers</span>?
        </h3>
        <p className="text-sm text-center lg:text-base xl:text-2xl lg:pt-5 xl:pt-7 text-[#090808] pt-2 w-full max-w-3xl xl:max-w-4xl">
          Joining us couldn't be easier! Check out our application process down
          below. If you have the talent we need, then we'll be meeting you soon!
        </p>
      </div>
      <div className="my-5 flex justify-center items-center w-full pt-4">
        <div className="grid grid-cols-4 md:grid-cols-7 justify-center items-center w-full px-16 md:px-16">
          <div className="col-span-3 hidden md:grid gap-20 pt-2 justify-end items-end w-full h-full">
            {timelineData.map((data, index) => (
              <div key={data.id} className="h-[7rem] md:h-[4rem]">
                {data.id % 2 === 0 ? (
                  <div className="flex flex-col gap-2 ">
                    <h3
                      className={clsx(
                        "lg:text-lg xl:text-[1.6rem] w-full white font-semibold text-right",
                        {
                          "text-[#0825D7]": data.id === timelineData.length,
                        },
                      )}
                    >
                      {data.title}
                    </h3>
                    <div className="w-full flex justify-end items-end">
                      <p className="lg:text-sm xl:text-base text-xs text-neutral-700 md:text-[#53648B] text-right max-w-[26rem]">
                        {data.description}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ))}
          </div>
          <div className="col-span-1 grid justify-center items-start gap-20 h-full">
            {timelineData.map((data, index) => (
              <div key={data.id} className="relative h-auto">
                <div className="flex">
                  <div
                    className={clsx(
                      `rounded-full bg-white shadow font-medium z-10`,
                      {
                        "border-2 border-blue-600 border-primary-500":
                          data.id === 1,
                        "py-4 px-[1.19rem]": data.id !== timelineData.length,
                      },
                    )}
                  >
                    {data.id === timelineData.length ? (
                      <div className="flex justify-center items-center p-[1.20rem]">
                        <img
                          src="/aboutus/hand-emoji.png"
                          alt=""
                          className="w-4"
                        />
                      </div>
                    ) : (
                      <div className="text-sm">0{data.id}</div>
                    )}
                  </div>
                </div>
                {index !== timelineData.length - 1 ? (
                  <div className="absolute left-1/2 top-full h-44 md:h-32 w-0.5 bg-neutral-300 -translate-x-1/2" />
                ) : (
                  <div className="absolute left-1/2 top-full h-0 w-0.5 bg-neutral-300 -translate-x-1/2" />
                )}
              </div>
            ))}
          </div>

          <div className="col-span-3 grid md:hidden gap-20 pt-2 justify-start items-start h-full">
            {timelineData.map((data, index) => (
              <div
                key={data.id}
                className="flex flex-col gap-2 h-[7rem] md:h-[4rem]"
              >
                <h3 className="lg:text-lg xl:text-[1.6rem] w-full white font-semibold text-left">
                  {data.title}
                </h3>
                <div className="w-full justify-start items-start max-w-72">
                  <p className="lg:text-sm xl:text-base text-xs text-neutral-700 md:text-[#53648B] text-left max-w-[26rem]">
                    {data.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="col-span-3 hidden md:grid gap-20 pt-2  justify-start w-full items-start h-full">
            {timelineData.map((data, index) => (
              <div key={data.id} className="h-[7rem] md:h-[4rem]">
                {data.id % 2 !== 0 ? (
                  <div className="flex flex-col gap-2 ">
                    <h3 className="lg:text-lg xl:text-[1.6rem] w-full white font-semibold">
                      {data.title}
                    </h3>
                    <div className="w-full justify-start items-start">
                      <p className="lg:text-sm xl:text-base text-xs text-neutral-700 md:text-[#53648B] max-w-[26rem]">
                        {data.description}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerTimeline;
